import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78faa4a7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=78faa4a7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78faa4a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78faa4a7')) {
      api.createRecord('78faa4a7', component.options)
    } else {
      api.reload('78faa4a7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=78faa4a7&scoped=true", function () {
      api.rerender('78faa4a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerNimService/components/index.vue"
export default component.exports